export default __webpack_public_path__ + "static/media/02__o_preview_3.6606c65a.jpg";